<template>
  <v-dialog
    v-model="dialogConfirm.open"
    @keydown.esc="dialogConfirm.open = false"
    persistent
    content-class="small"
  >
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              Delete <b>{{ dialogConfirm.name }}</b
              >?
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          id="btn-close"
          class="btn-secondary"
          @click="dialogConfirm.open = false"
        >
          Cancel
        </v-btn>

        <v-btn id="btn-ok" class="btn-primary" @click="dialogConfirmClick">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogConfirmCampaignVoice',
  props: {
    dialogConfirm: Object
  },
  methods: {
    dialogConfirmClick() {
      this.$emit('dialogConfirmClick', null)
    }
  }
}
</script>
